import Vue from 'vue';
import Settings from './src/settings';

/*
 * Events:
 * - sendMessage(message)
 * - typing(true|false)
 * - closeRoomTab(target)
 * - selectRoom(target)
 * - createRoom(name)
 * - removeCurrentRoom()
 * - joinRoom(target)
 *
 * Event methods:
 * - setMessages(arr)
 * - addMessage(msg)
 * - setFocusToMessageInput()
 * - resetAutocompletion()
 */
export default new Vue({
	data: {
		state: {
			connected: false,
			baseDomain: 'sinair.ru',
			currentUser: {
				id: 0,
				login: 'Гость',
			},
			settings: Settings,

			messageText: '',
			isScrolledEnd: true,
			currentPanel: 'chat',

			onlineList: [],
			typingList: [],

			roomTabs: [],
			activeTab: '',
		},
	},

	methods: {
		updateUser(userInfo){
			this.state.currentUser = {
				id: userInfo.user_id,
				login: userInfo.name,
			};
		},
	},

	watch: {
		'state.settings':{
			handler(settings){
				settings.save();
			},
			deep: true,
		},
	},
});
